"use client";

import { useEffect } from "react";

export default function OverlayReady() {
  useEffect(() => {
    const sendReady = () => {
      try {
        window.dispatchEvent(new CustomEvent("overlay:ready"));
      } catch {}
    };
    // Next tick after first paint
    requestAnimationFrame(() => {
      setTimeout(sendReady, 0);
    });
  }, []);
  return null;
}


